import { signIn } from "../features/auth/authSlice";
import { useDispatch } from "react-redux";
import axios from "../api/axios";
import { jwtDecode } from "jwt-decode";

const useRefreshToken = () => {
  const dispatch = useDispatch();

  const refresh = async () => {
    try {
      const response = await axios.get("account/refresh/token", {
        withCredentials: true,
      });

      const { access } = response?.data;
      const decoded = jwtDecode(access);
      const user_id = decoded.user_id;
      const roles = decoded.roles;
      const org_control_access = decoded?.org_control_access;
      dispatch(
        signIn({
          user_id,
          roles,
          access,
          org_control_access,
        }),
      );

      return access;
    } catch (error) {
      // window.location.href = "/somethingwentwrong";
      console.error("Error refreshing token:", error);
    }
  };
  return refresh;
};

export default useRefreshToken;
